/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Empty_FileInputs */

const en_us2_history_transfer_empty_file = /** @type {(inputs: History_Transfer_Empty_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are no workouts in this file.`)
};

const pt_br2_history_transfer_empty_file = /** @type {(inputs: History_Transfer_Empty_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há treinos neste arquivo.`)
};

const es_419_history_transfer_empty_file = /** @type {(inputs: History_Transfer_Empty_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay entrenamientos en este archivo.`)
};

const pt_pt2_history_transfer_empty_file = /** @type {(inputs: History_Transfer_Empty_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há treinos neste ficheiro.`)
};

const fr_fr2_history_transfer_empty_file = /** @type {(inputs: History_Transfer_Empty_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce fichier ne contient aucune séance.`)
};

const de_de2_history_transfer_empty_file = /** @type {(inputs: History_Transfer_Empty_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In dieser Datei sind keine Trainings.`)
};

const it_it2_history_transfer_empty_file = /** @type {(inputs: History_Transfer_Empty_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In questo file non ci sono allenamenti.`)
};

/**
* | output |
* | --- |
* | "There are no workouts in this file." |
*
* @param {History_Transfer_Empty_FileInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_empty_file = /** @type {((inputs?: History_Transfer_Empty_FileInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Empty_FileInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_empty_file(inputs)
	if (locale === "es-419") return es_419_history_transfer_empty_file(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_empty_file(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_empty_file(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_empty_file(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_empty_file(inputs)
	return en_us2_history_transfer_empty_file(inputs)
});
export { history_transfer_empty_file as "history-transfer.empty_file" }